import ImportCustomersRequestModelBase from '../_generated/modelBases/import-customers-request-model-base';

export default class ImportCustomersRequestModel extends ImportCustomersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
